module.exports = __webpack_public_path__ + "gh.cc4d28515198879298e9.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/gh.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/gh.svg
// module chunks = styles